import { type WrappedInsightNightShiftLegendAttributes } from "@clipboard-health/contract-backend-main";
import { Image, Span, Text } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";

import owlIcon from "../../assets/owl-wrapped.png";

interface NightShiftLegendContentProps {
  attributes: WrappedInsightNightShiftLegendAttributes;
}

export function NightShiftLegendContent(props: NightShiftLegendContentProps) {
  const { attributes } = props;

  return (
    <Stack flex={1} position="relative" overflow="hidden">
      {/* Text section - top left */}
      <Stack
        position="absolute"
        sx={{
          top: "12%",
          left: "7.7%",
        }}
        gap={1}
      >
        <Text variant="body1" color="white">
          You are a
        </Text>
        <Text variant="h1" color="white" sx={{ fontSize: "3.5rem", lineHeight: 1 }}>
          Nightshift
        </Text>
        <Text variant="h1" color="white" sx={{ fontSize: "3.5rem", lineHeight: 1 }}>
          Legend
        </Text>
        <Text variant="body2" sx={{ marginTop: 2 }}>
          <Span sx={{ color: "rgba(255, 255, 255, 0.6)" }}>
            {attributes.amShifts} AM Shifts · {attributes.pmShifts} PM Shifts ·{" "}
          </Span>
          <Span sx={{ fontWeight: 500, color: "white" }}>{attributes.nocShifts} NOC Shifts</Span>
        </Text>
      </Stack>

      {/* Owl image - positioned based on Figma: 266.67x400 at top 406px on 375x812 page */}
      <Box
        position="absolute"
        sx={{
          top: "50%", // 406 / 812 = 50%
          left: 0,
        }}
      >
        <Image src={owlIcon} alt="Owl" width="71vw" height="auto" />
      </Box>
    </Stack>
  );
}
